import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { Container, Form, Table, Button, InputGroup } from "react-bootstrap";
import { MdDeleteOutline, MdAddCircleOutline } from "react-icons/md";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";
import { useTranslation } from "react-i18next";

const PageAdminDroitsConsultation = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();
  const [emailsAutorises, setEmailsAutorises] = useState([]);
  const [emailsRefuses, setEmailsRefuses] = useState([]);
  const [domainesAutorises, setDomainesAutorises] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleAddEmailAutorise = () => {
    const emailsCopy = [
      ...emailsAutorises,
      "collaborateur_" + emailsAutorises.length + "@domaine.com",
    ];
    setEmailsAutorises(emailsCopy);
  };
  const handleChangeEmailAutorise = (index, email) => {
    const emailsCopy = [...emailsAutorises];
    emailsCopy[index] = email;
    setEmailsAutorises(emailsCopy);
  };
  const handleDeleteEmailAutorise = (index) => {
    const emailsCopy = [...emailsAutorises];
    emailsCopy.splice(index, 1);
    setEmailsAutorises(emailsCopy);
  };

  const handleAddEmailRefuse = () => {
    const emailsCopy = [
      ...emailsRefuses,
      "collaborateur_" + emailsRefuses.length + "@domaine.com",
    ];
    setEmailsRefuses(emailsCopy);
  };
  const handleChangeEmailRefuse = (index, email) => {
    const emailsCopy = [...emailsRefuses];
    emailsCopy[index] = email;
    setEmailsRefuses(emailsCopy);
  };
  const handleDeleteEmailRefuse = (index) => {
    const emailsCopy = [...emailsRefuses];
    emailsCopy.splice(index, 1);
    setEmailsRefuses(emailsCopy);
  };

  const handleAddDomain = () => {
    const emailsCopy = [
      ...domainesAutorises,
      "domaine" + domainesAutorises.length + ".com",
    ];
    setDomainesAutorises(emailsCopy);
  };
  const handleChangeDomain = (index, email) => {
    const emailsCopy = [...domainesAutorises];
    emailsCopy[index] = email;
    setDomainesAutorises(emailsCopy);
  };
  const handleDeleteDomain = (index) => {
    const emailsCopy = [...domainesAutorises];
    emailsCopy.splice(index, 1);
    setDomainesAutorises(emailsCopy);
  };

  const submitData = async (e) => {
    setLoader(true);
    e.preventDefault();
    const dataForm = {
      domainesAutorises: [],
      emailsAutorises: [],
      emailsRefuses: [],
    };
    dataForm.domainesAutorises = domainesAutorises.sort();
    dataForm.emailsAutorises = emailsAutorises.sort();
    dataForm.emailsRefuses = emailsRefuses.sort();
    await apiUpdateInstance(ReduxInstance._id, dataForm);
    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    dispatch(chgInstance(res.data));
    setLoader(false);
  };

  useEffect(() => {
    setEmailsAutorises(
      ReduxInstance.emailsAutorises
        .filter((x, i, a) => a.indexOf(x) === i)
        .sort()
    );
    setEmailsRefuses(
      ReduxInstance.emailsRefuses.filter((x, i, a) => a.indexOf(x) === i).sort()
    );
    setDomainesAutorises(
      ReduxInstance.domainesAutorises
        .filter((x, i, a) => a.indexOf(x) === i)
        .sort()
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <Form onSubmit={submitData}>
          <ComponentTitle
            title={t("admin.PageAdminDroitsConsultation.titre")}
          />
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr className="text-center">
                <th>{t("admin.PageAdminDroitsConsultation.titreColonne1")}</th>
                <th>{t("admin.PageAdminDroitsConsultation.titreColonne2")}</th>
                <th>{t("admin.PageAdminDroitsConsultation.titreColonne3")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span role="button" onClick={(e) => handleAddDomain()}>
                    <MdAddCircleOutline size="1.5em" />
                    {t(
                      "admin.PageAdminDroitsConsultation.buttonAjouterDomaine"
                    )}
                  </span>
                </td>
                <td>
                  <span role="button" onClick={(e) => handleAddEmailAutorise()}>
                    <MdAddCircleOutline size="1.5em" />
                    {t(
                      "admin.PageAdminDroitsConsultation.buttonAutoriserEmail"
                    )}
                  </span>
                </td>
                <td>
                  <span role="button" onClick={(e) => handleAddEmailRefuse()}>
                    <MdAddCircleOutline size="1.5em" />
                    {t("admin.PageAdminDroitsConsultation.buttonRefuserEmail")}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {domainesAutorises.map((domaine, index) => (
                    <div
                      className="input-group mt-2 mb-2"
                      key={"domaine_" + index}
                    >
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDeleteDomain(index)}
                      />
                      <InputGroup.Text id="basic-addon1">@</InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="domaines"
                        value={domaine}
                        onChange={(e) =>
                          handleChangeDomain(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
                </td>
                <td>
                  {emailsAutorises.map((email, index) => (
                    <div
                      className="input-group mt-2 mb-2"
                      key={"emailautorise_" + index}
                    >
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDeleteEmailAutorise(index)}
                      />
                      <Form.Control
                        type="text"
                        name="emails"
                        value={email}
                        onChange={(e) =>
                          handleChangeEmailAutorise(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
                </td>
                <td>
                  {emailsRefuses.map((email, index) => (
                    <div
                      className="input-group mt-2 mb-2"
                      key={"emailrefuse_" + index}
                    >
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDeleteEmailRefuse(index)}
                      />
                      <Form.Control
                        type="text"
                        name="emails"
                        value={email}
                        onChange={(e) =>
                          handleChangeEmailRefuse(index, e.target.value)
                        }
                      />
                    </div>
                  ))}
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="text-end mb-5">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
      </Container>
    </>
  );
};

export default PageAdminDroitsConsultation;
